var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("date date--color-" + _vm.color),attrs:{"aria-label":_vm.$MKSlocale['date']}},[_c('div',{staticClass:"date__number"},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.number)+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }